gsap.registerPlugin(ScrollTrigger);

// Gradient animation on "NEW" text
gsap.to("#gradient-text", {
  scrollTrigger: {
    trigger: ".scroll-container",
    start: "top top",
    end: "bottom bottom",
    scrub: true
  },
  backgroundPosition: "-900% 0", // 10 frames (adjust based on your sprite sheet)
  ease: "steps(10)" // Snap to each frame
});

// Hand animation (move down from top)
gsap.to("#hand-animation", {
  scrollTrigger: {
    trigger: ".scroll-container",
    start: "top top",
    end: "bottom bottom",
    scrub: true
  },
  top: "20%", // End position (adjust as needed)
  ease: "linear"
});